var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-radio-input__wrapper"},[_c('input',{staticClass:"ui-radio-input",attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.shouldBeChecked},on:{"click":_vm.handleClick,"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }